export const EDebugFeature = {
  MEMORY: 'MEMORY',
  FPS: 'FPS',
} as const;

export type TDebugFeature = (typeof EDebugFeature)[keyof typeof EDebugFeature];
